import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'wct-horizontal-layout',
  standalone: true,
  imports: [CommonModule],
  template: '<ng-content/>',
  styleUrls: ['./horizontal-layout.component.scss'],
  host: { '[class.space-between]': 'spaceBetween' },
})
export class HorizontalLayoutComponent {
  @Input({ required: false }) public spaceBetween: boolean;
}
